<template>
  <b-col cols="6" class="">
    <div class="small-stat-container p-3">
      <p class="value mb-0">{{ value }}</p>
      <p class="type mb-0">{{ type }}</p>
      <p class="rank mb-0">Top 1000</p>
    </div>
  </b-col>
</template>

<script>
export default {
  name: "StatBoxSmall",
  props: ["type", "value"],
  data: function() {
    return {};
  },
};
</script>

<style scoped>
.small-stat-container {
  border: 1px solid white;
  height: 176px;
}

.value {
  font-size: 60px;
  font-weight: 200;
  line-height: 60px;
}

.type {
  font-size: 24px;
  font-weight: 300;
  line-height: 35px;
}

.rank {
  font-size: 14px;
  font-weight: 900;
  line-height: 20px;
}

@media (min-width: 576px) {
  .small-stat-container {
    border: 1px solid white;
    height: 179px;
  }

  .value {
    font-size: 60px;
    font-weight: 200;
    line-height: 60px;
  }

  .type {
    font-size: 24px;
    font-weight: 300;
    line-height: 35px;
  }

  .rank {
    font-size: 14px;
    font-weight: 900;
    line-height: 20px;
  }
}

@media (min-width: 768px) {
  .small-stat-container {
    border: 1px solid white;
    height: 179px;
  }

  .value {
    font-size: 60px;
    font-weight: 200;
    line-height: 60px;
  }

  .type {
    font-size: 24px;
    font-weight: 300;
    line-height: 35px;
  }

  .rank {
    font-size: 14px;
    font-weight: 900;
    line-height: 20px;
  }
}

@media (min-width: 992px) {
  .small-stat-container {
    border: 1px solid white;
    height: 179px;
  }

  .value {
    font-size: 60px;
    font-weight: 200;
    line-height: 60px;
  }

  .type {
    font-size: 24px;
    font-weight: 300;
    line-height: 35px;
  }

  .rank {
    font-size: 14px;
    font-weight: 900;
    line-height: 20px;
  }
}

@media (min-width: 1200px) {
  .small-stat-container {
    border: 1px solid white;
    height: 153px;
  }

  .value {
    font-size: 60px;
    font-weight: 200;
    line-height: 60px;
  }

  .type {
    font-size: 24px;
    font-weight: 300;
    line-height: 35px;
  }

  .rank {
    font-size: 14px;
    font-weight: 900;
    line-height: 20px;
  }
}
</style>
